import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SeismicClaimTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-seismic-claim-type',
  templateUrl: './seismic-claim-type.component.html',
  styleUrls: ['./seismic-claim-type.component.scss']
})
export class SeismicClaimTypeComponent implements OnInit {

  seismicclaimtypeForm: FormGroup;
  seismicclaimtypeFormArray: FormGroup;
  control = new FormControl();
  @Input() seismicclaimtypes: SeismicClaimTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() seismicclaimtype = new EventEmitter<SeismicClaimTypeDto[]>()
  @Output() deleteSeismicClaimTypeEvent = new EventEmitter<any>()

    selectedSeismicClaimType: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnInit() {
      this.createSeismicClaimTypeForm();
    }

    createSeismicClaimTypeForm() {
      this.seismicclaimtypeForm = this.fb.group({
      ClaimTypeName: ['', Validators.required],
      ClaimAddress: ['', Validators.required],
      ClaimTypeEmail: ['', Validators.required],
      ClaimPhoneNo: ['', Validators.required],
        id: null
        });
        this.seismicclaimtypeFormArray = this.fb.group({ SeismicClaimTypes: this.fb.array([])
          });
        this.setSeismicClaimType();
    }

  // method to display seismicclaimtypes
  setSeismicClaimType() {
    const control  = this.seismicclaimtypeFormArray.controls.SeismicClaimTypes as FormArray;
    this.seismicclaimtypes.forEach( e => {
      control.push(
        this.fb.group({
          ClaimTypeName: e.ClaimTypeName,
          ClaimAddress: e.ClaimAddress,
          ClaimTypeEmail: e.ClaimTypeEmail,
          ClaimPhoneNo: e.ClaimPhoneNo,
          id: e.id
        })
      );
    });
  }


  // method to add SeismicClaimType
  addSeismicClaimType(value: SeismicClaimTypeDto) {
    const control  = this.seismicclaimtypeFormArray.controls.SeismicClaimTypes as FormArray;
    control.insert(0,
          this.fb.group({
            ClaimTypeName: value.ClaimTypeName,
            ClaimAddress: value.ClaimAddress,
            ClaimTypeEmail: value.ClaimTypeEmail,
            ClaimPhoneNo: value.ClaimPhoneNo,
            id: null
          })
       );
  }

  selectSeismicClaimType(value) {}

  // method to delete seismicclaimtype from arrary list
  deleteSeismicClaimType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.seismicclaimtypeFormArray.controls.SeismicClaimTypes as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.seismicclaimtypes.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.seismicclaimtypes[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: SeismicClaimTypeDto) {
    if(this.seismicclaimtypeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.seismicclaimtypeFormArray.get('SeismicClaimTypes')['controls'][this.selectedIndex].patchValue({ClaimTypeName: formValue.ClaimTypeName, ClaimAddress: formValue.ClaimAddress, ClaimTypeEmail: formValue.ClaimTypeEmail, ClaimPhoneNo: formValue.ClaimPhoneNo,});
    } else {
      this.addSeismicClaimType(formValue);
    }
    this.selectedIndex = null;
    this.seismicclaimtypeForm.reset()
  }

  onEdit(index, value: SeismicClaimTypeDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.seismicclaimtypeForm.patchValue({ClaimTypeName: value.ClaimTypeName, ClaimAddress: value.ClaimAddress, ClaimTypeEmail: value.ClaimTypeEmail, ClaimPhoneNo: value.ClaimPhoneNo,});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.seismicclaimtypeForm.reset();
  }

  onSubmit(formValue: SeismicClaimTypeDto[]) {
  this.seismicclaimtype.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteSeismicClaimTypeEvent.emit(this.filteredDelete);
  }
  }

}
